import { gsap } from "gsap";
import { Observer } from "gsap/Observer";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(Observer, ScrollTrigger, ScrollSmoother, ScrollToPlugin);
ScrollSmoother.create({
    smooth: 2,
    speed:1,
    effects: true,
    smoothTouch: 0.1,
    // normalizeScroll: true
});

//-> JQuery
window.$ = window.jQuery = require('jquery');
import * as bootstrap from 'bootstrap';
import Svg from "./components/Svg";
import MotionsOne from "./components/MotionsOne";


Svg.init();
MotionsOne.init();
